import React from 'react'
import Moment from 'react-moment'
import { Badge } from 'reactstrap'

const LastSyncDetails = (props) => {
  if (props.selectedCompany) {
    const isValid = new Date(props.selectedCompany.lastSyncDate) > new Date('01/01/2000 00:00')

    if (isValid && props.selectedCompany.lastSyncResult !== null) {
      const syncStyle =
          props.selectedCompany.lastSyncResult === 'Skipped'
              ? 'Secondary'
          : props.selectedCompany.lastSyncResult.toLowerCase()

      return (
        <span>
          <Moment format="DD/MM/YYYY">{props.selectedCompany.lastSyncDate}</Moment>{' '}
          <Badge style={{ fontSize: '14px', verticalAlign: 'middle', marginLeft: '5px', marginBottom: '6px' }} color={syncStyle}>
            {props.selectedCompany.lastSyncResult}
          </Badge>
        </span>
      )
    } else {
      return <span>No Synchronizations</span>
    }
  } else {
    return <span>Loading</span>
  }
}

export default LastSyncDetails
